import React from 'react';
import { Edit, TabbedForm, FormTab, NumberInput, BooleanInput, Toolbar, SaveButton, useRefresh, useNotify } from 'react-admin';

const CarbonizerEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);

export const CarbonSettings = (props) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const onSuccess = ({data}) => {
    notify(`Changes to Settings were saved`);
    refresh();
  }
  return (
  <Edit title='Optimizer Settings' resource='carbon/settings' basePath='settings' mutationMode="pessimistic" onSuccess={onSuccess} {...{id: 1}}>
    <TabbedForm toolbar={<CarbonizerEditToolbar />}>

    <FormTab label="Optimizer">
        <br/>
        <BooleanInput source="carbon_auction_optimizer_config.active" label="Active" style={{width: '260px'}}/>

        <h4>Date Range (Start &gt; End)</h4>
        <NumberInput source="carbon_auction_optimizer_config.start_day_offset" label="Start Day Offset"
        helperText="How far back should the report start."
        />
        
        <NumberInput source="carbon_auction_optimizer_config.end_day_offset" label="End Day Offset"
        helperText="How far back should the report stop." />

        <br/><hr style={{width: '100%'}} /><br/>

        <NumberInput source="carbon_auction_optimizer_config.impressions_minimum" label="Minimum Impressions"
            helperText="Block inventory where impressions is less or equal to the minimum" />

        <NumberInput source="carbon_auction_optimizer_config.revenue_minimum" label="Minimum Revenue ($)"
            helperText="Block inventory where revenue is less or equal to the minimum" />

        <NumberInput source="carbon_auction_optimizer_config.bid_responses_rate_minimum" label="Minimum Response Rate %"
            helperText="Block inventory where bid response rate is less or equal to the minimum (bid responses/bid requests)"/>

        <NumberInput source="carbon_auction_optimizer_config.fill_rate_minimum" label="Minimum Fill Rate %"
            helperText="Block inventory where fill rate is less or equal to the minimum (impressions/ad requests)"/>

        <NumberInput source="carbon_auction_optimizer_config.rpm_bid_requests_minimum" label="Minimum RPM Rate ($)"
            helperText="Block inventory where RPM is less or equal to the minimum (1,000,000 * $revenue/#bid requests)."/>

        <br/><br/><br/><br/>
        
    </FormTab>

    </TabbedForm>
    </Edit>
  )
}